"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.containsInvalidFiles = exports.allowedFormats = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var Icon_1 = require("components/Icon");
exports.allowedFormats = [
    'FOLDER',
    'DWG',
    'PDF',
    'TEXT',
    'PRESENTATION',
    'IMAGE',
    'SPREADSHEET'
];
var containsInvalidFiles = function (x) {
    var hasInvalidFiles = x.filter(function (y) {
        return !exports.allowedFormats.includes(y.type) && y.type !== 'FOLDER';
    });
    return hasInvalidFiles.length > 0;
};
exports.containsInvalidFiles = containsInvalidFiles;
var formats = 'pdf, dwg, plt, rtf, doc, docx, odt, wpd, wps, ppt, pptx, pps, ppsx, jpg, jpeg, gif, bmp, png, tif, tiff, eps, xls, xlsx, csv, txt, pub, odp, ods, odg';
var enhance = recompose_1.pure;
exports.default = enhance(function (props) {
    return (React.createElement(sok_ui_1.Row, { style: props.style },
        React.createElement(sok_ui_1.Column, { small: 12 },
            React.createElement("div", { className: 'contains-invalid-files' },
                React.createElement("div", { className: "warning-icon" },
                    React.createElement(Icon_1.Icon, { className: "fa-exclamation-triangle", prefix: 'fas' })),
                React.createElement("div", { className: 'warning-message' },
                    React.createElement("div", { className: 'message' }, props.mode === 'EDIT'
                        ? (0, translation_1.getLocalization)('userfront/shoppingcart/invalidFiles/NotifyText/editMode')
                        : (0, translation_1.getLocalization)('userfront/shoppingcart/invalidFiles/NotifyText')),
                    React.createElement("div", { className: 'allowed-formats' }, (0, translation_1.getLocalization)('orderwizard/invalidFiles/allowedfileformats', [
                        formats
                    ]))))),
        React.createElement(sok_ui_1.Column, null,
            React.createElement("div", { className: 'contains-invalid-files-checkbox' },
                React.createElement(sok_ui_1.Input, { id: 'is-client', type: 'checkbox', onClick: function () { return props.toggleProceedWithoutInvalidFiles(); }, label: (0, translation_1.getLocalization)('userfront/shoppingcart/invalidFiles/NotifyTextAccept'), value: props.proceedWithoutInvalidFiles })),
            props.status === 'ERROR' &&
                props.errors['proceedWithoutInvalidFiles'] && (React.createElement("p", { className: 'form-error' }, props.errors['proceedWithoutInvalidFiles'][0])))));
});
